/**
 * @module events/types/load
 */

/**
 * @type {string}
 */
export default 'load'
